import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import H3 from 'UIComponents/elements/headings/H3';
import UIList from 'UIComponents/list/UIList';
import UILink from 'UIComponents/link/UILink';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIIcon from 'UIComponents/icon/UIIcon';

const NoopExternalIcon = () => null;

const ExternalLink = props => /*#__PURE__*/_jsx(UILink, Object.assign({}, props, {
  ExternalIcon: NoopExternalIcon,
  external: true
}));

export default function AssetContactInfo({
  chatUrl,
  facebookUrl,
  getAssetEventSelectorId = () => '',
  onTrackInteraction,
  phone,
  provider,
  supportEmail
}) {
  const trackInteraction = useCallback(value => {
    if (onTrackInteraction) {
      onTrackInteraction(value);
    }
  }, [onTrackInteraction]);
  const {
    name: providerName
  } = provider;
  const [phoneNumber, phoneExtension] = phone ? phone.split('-') : [];
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(H3, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-assets-core.details.contact.title",
        options: {
          providerName
        }
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      children: [/*#__PURE__*/_jsxs(UICopyButton, {
        "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-EMAIL'),
        onClick: () => trackInteraction('click copy email address'),
        use: "link",
        value: supportEmail,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "email"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-assets-core.details.contact.supportEmail"
        })]
      }), chatUrl && /*#__PURE__*/_jsxs(ExternalLink, {
        "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-CHAT'),
        href: chatUrl,
        onClick: () => trackInteraction('click live chat link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "messages"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-assets-core.details.contact.chatUrl"
        })]
      }), facebookUrl && /*#__PURE__*/_jsxs(ExternalLink, {
        "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-FACEBOOK'),
        href: facebookUrl,
        onClick: () => trackInteraction('click facebook link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "socialBlockFacebook"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-assets-core.details.contact.facebookUrl"
        })]
      }), phone && /*#__PURE__*/_jsxs(ExternalLink, {
        "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-PHONE'),
        href: `tel: ${phoneNumber}`,
        onClick: () => trackInteraction('click phone number link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "calling"
        }), /*#__PURE__*/_jsx(FormattedPhoneNumber, {
          value: phoneNumber // @ts-expect-error I18n props are wrong for this component
          ,
          extension: phoneExtension
        })]
      })]
    })]
  });
}